import { sceconfig } from 'sce-core';

export const environment = {
  production: true,
  baseUrlUI: sceconfig.wms.baseUrlUI,

  wmsApiBaseUrl: 'https://wms.ocf.fulfillment.maersk.com.cn/scecommon/', // wrb prod CN envrionment
  notificationApiBaseUrl: 'https://tms.ocf.fulfillment.maersk.com.cn/api', // wrb prod CN envrionment

  RUM_APP_ID: 'TMSWeb-PROD',
  RUM_API_KEY: '8mbsP9GGADglPMlmBU2flCYY6YJp4KrcJ6X7CYiV2ftWMxX8qqRsAq3OVTdanQ==',
};
